export default __webpack_public_path__ + "ec3267f1bf6dbdb0bd15f46ce3d819fa.svg";